import React from 'react';

import ReviewInfo from '../coach/ReviewInfo';

import { type PackageReviewInfoCategoryFragment } from './__generated-gql-types__/PackageReviewInfo.generated';

interface PackageReviewInfoProps {
  category: PackageReviewInfoCategoryFragment;
}

export const PackageReviewInfo: React.FC<PackageReviewInfoProps> = ({
  category,
}) => {
  return (
    <ReviewInfo
      averageReviewRate={category.averageReviewRate}
      showReviewButton={false}
    />
  );
};
